import type { Components, Theme } from '@mui/material/styles';

export const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: ({ theme: { spacing, breakpoints } }) => ({
      paddingInline: spacing(2),
      [breakpoints.down('sm')]: {
        paddingInline: spacing(1),
      },
      '& .Mui-expanded': {
        margin: `${spacing(1.5)} 0`,
      },
    }),
  },
};
